module.exports = __webpack_public_path__ + "img/icon-monthly-attribution.15facad8.svg";